import { createAction, createReducer } from "@reduxjs/toolkit"
import _ from "lodash"
import httpClient from "../../../api/httpClient"
import appStore from "../../../appStore"

const fetAllUserProfileResult = createAction("userProfile/fetchAll")
const clear = createAction("userProfile/clear")

function create(profile) {
  return (dispatch, getState) =>
    httpClient.post("/api/userprofile", profile).then(({ data }) => {
      const profiles = getState()["admin.userProfile"]
      dispatch(fetAllUserProfileResult([data, ...profiles]))
    })
}

function update(profile) {
  return (dispatch, getState) =>
    httpClient.put(`/api/userprofile/${profile._id}`, profile).then(() => {
      const profiles = getState()["admin.userProfile"]
      const newProfiles = profiles.map((it) => {
        if (it._id === profile._id) {
          return profile
        }
        return it
      })

      dispatch(fetAllUserProfileResult(newProfiles))
    })
}

function fetchAll() {
  return (dispatch) =>
    httpClient
      .get("/api/userprofile")
      .then(({ data }) => dispatch(fetAllUserProfileResult(data)))
}

function deleteOne(profile) {
  return (dispatch, getState) =>
    httpClient.post("/api/userprofile/deleteMany", [profile._id]).then(() => {
      const prevProfiles = getState()["admin.userProfile"]
      const newProfiles = prevProfiles.filter((it) => it._id !== profile._id)
      dispatch(fetAllUserProfileResult(newProfiles))
    })
}

function deleteMany(profiles) {
  return (dispatch, getState) =>
    httpClient.post("/api/userprofile/deleteMany", profiles).then(() => {
      const deletedProfilesByID = _.groupBy(profiles, "_id")
      const prevProfiles = getState()["admin.userProfile"]
      const newProfiles = prevProfiles.filter(
        (it) => !deletedProfilesByID[it._id]
      )
      dispatch(fetAllUserProfileResult(newProfiles))
    })
}

const reducer = createReducer([], {
  "userProfile/fetchAll": (state, { payload }) => {
    return payload
  },
  "userProfile/clear": () => {
    return []
  }
})

appStore.injectReducer("admin.userProfile", reducer)

export default {
  actions: { create, update, fetchAll, deleteOne, deleteMany, clear }
}
